<app-internaluser [state]="viewState.Details"></app-internaluser>